import { render, staticRenderFns } from "./feedback-read.component.vue?vue&type=template&id=e49a0e28&scoped=true&"
import script from "./feedback-read.component.vue?vue&type=script&lang=ts&"
export * from "./feedback-read.component.vue?vue&type=script&lang=ts&"
import style0 from "./feedback-read.component.vue?vue&type=style&index=0&id=e49a0e28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49a0e28",
  null
  
)

export default component.exports